import { render } from "./SidebarContent.vue?vue&type=template&id=76a0dbb4&ts=true"
import script from "./SidebarContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarContent.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76a0dbb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76a0dbb4', __exports__)) {
    api.reload('76a0dbb4', __exports__)
  }
  
  module.hot.accept("./SidebarContent.vue?vue&type=template&id=76a0dbb4&ts=true", () => {
    api.rerender('76a0dbb4', render)
  })

}


export default __exports__